import React, { Component } from 'react';
import BloxButton from 'sub_components/Common/BloxButton';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const LowDefault = `${CDN_URL}common/low-priority-default-lg.svg`;
const LowSelected = `${CDN_URL}common/low-priority-selected-lg.svg`;
const MedDefault = `${CDN_URL}common/medium-priority-default-lg.svg`;
const MedSelected = `${CDN_URL}common/medium-priority-selected-lg.svg`;
const HighDefault = `${CDN_URL}common/high-priority-default-lg.svg`;
const HighSelected = `${CDN_URL}common/high-priority-selected-lg.svg`;

class PrioritySelection extends Component {
	onMouseEnter = id => {
		const icon = document.getElementById(id);

		if (id === 'LOW') {
			icon.src = LowSelected;
		} else if (id === 'MED') {
			icon.src = MedSelected;
		} else if (id === 'HIGH') {
			icon.src = HighSelected;
		} else {
			icon.src = MedSelected;
		}
	};
	onMouseLeave = (id, typeIcon) => {
		const icon = document.getElementById(id);
		icon.src = typeIcon;
	};

	componentDidMount() {
		const { data, onSelect } = this.props;
		if (data.type === 'outage' && !data.priority) {
			onSelect('priority', { data: 'high' }, true);
		}

		if (data.type === 'billing' && !data.priority) {
			onSelect('priority', { data: 'medium' }, true);
		}
	}
	render() {
		const { data, onSelect, closeModal } = this.props;
		const selected = data.priority;
		const lowIcon = selected === 'low' ? LowSelected : LowDefault;
		const medIcon = selected === 'medium' ? MedSelected : MedDefault;
		const highIcon = selected === 'high' ? HighSelected : HighDefault;

		return (
			<div className='priority-selection-stage'>
				<div className={'priority-selection-wrapper'}>
					<div
						className='priority-selection'
						onClick={() => onSelect('priority', { data: 'low' }, true)}
						onMouseEnter={() => this.onMouseEnter('LOW')}
						onMouseLeave={() => this.onMouseLeave('LOW', lowIcon)}
						data-cy='priority-low'
						id='priority-low'
					>
						<img src={lowIcon} id='LOW' />
						<div className='title heading76'>Low</div>
					</div>

					<div
						className={`priority-selection`}
						onClick={() => onSelect('priority', { data: 'medium' }, true)}
						onMouseEnter={() => this.onMouseEnter('MED')}
						onMouseLeave={() => this.onMouseLeave('MED', medIcon)}
						data-cy='priority-med'
						id='priority-med'
					>
						<img src={medIcon} id='MED' />
						<div className='title heading76'>Medium</div>
					</div>

					<div
						className={`priority-selection  `}
						onClick={() => onSelect('priority', { data: 'high' }, true)}
						onMouseEnter={() => this.onMouseEnter('HIGH')}
						onMouseLeave={() => this.onMouseLeave('HIGH', highIcon)}
						data-cy='priority-high'
						id='priority-high'
					>
						<img src={highIcon} id='HIGH' />
						<div className='title heading76'>High</div>
					</div>
				</div>

				<div className='cancel-button'>
					<BloxButton
						title='CANCEL'
						enabled={true}
						customClass='blox-button-swipe'
						onClick={closeModal}
						id='cancel-button-swipe'
					/>
				</div>
			</div>
		);
	}
}

export default PrioritySelection;
